<app-overlay
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowing.emit($event)"
  (onShown)="onShown.emit($event)"
  (onHiding)="onHiding.emit($event)"
  (onHidden)="onHidden.emit($event)"
  [container]="container"
  [overlayMask]="!!overlayMask"
  [deferRendering]="true"
  (onContentReady)="onContentReadyInternal()"
>
  <ng-template overlayContent>
    <app-scroll-view
      class="modal-scroll-container"
      [scrollable]="!!scrollEnabled"
    >
      <div
        class="modal {{ modalClass }} {{ minimized ? 'minimized-mode' : '' }}"
        #modalEl
        [ngClass]="{
          'modal-restrict-to-container-enabled': !!restrictDraggingToContainer,
          'draggable-enabled': !!draggableEnabled
        }"
        style="visibility: {{ rendered ? 'visible' : 'hidden' }};"
        (focus)="onModalFocus()"
        (mousedown)="onModalFocus()"
      >
        <app-card class="modal-content" [shapeType]="shapeType">
          <div
            class="modal-header drag-handle"
            [ngClass]="{
              'drag-handle': !!(draggableEnabled && useHeaderAsDragHandle)
            }"
            #modalHeaderEl
          >
            <app-toolbar *ngIf="!!showToolbar" class="toolbar">
              <ng-container
                *ngIf="modalTitleLocation === 'before'"
                appToolbarItemBefore
                [ngTemplateOutlet]="headerTitleTpl"
              ></ng-container>

              <ng-container
                *ngIf="modalTitleLocation === 'center'"
                appToolbarItemCenter
                [ngTemplateOutlet]="headerTitleTpl"
              ></ng-container>

              <ng-container appToolbarItemAfter>
                <ng-content select="[appToolbarItemAfter]"></ng-content>
              </ng-container>

              <app-button
                *ngIf="!!minimizeBtnEnabled"
                appToolbarItemAfter
                class="minimize-btn"
                buttonType="normal"
                styleType="text"
                shapeType="circle"
                sizeType="small"
                icon="assets/icons/{{
                  !minimized ? 'minus' : 'up-right-and-down-left-from-center'
                }}.svg"
                title="{{ minimizeTooltip }}"
                (click)="onBtnMinimizeToggleClick($event)"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
              ></app-button>

              <app-button
                *ngIf="!!closeBtnEnabled"
                appToolbarItemAfter
                class="close-btn"
                buttonType="normal"
                styleType="text"
                shapeType="circle"
                sizeType="small"
                icon="assets/icons/xmark.svg"
                title="{{ closeTooltip }}"
                (click)="onBtnCloseClick($event)"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
              ></app-button>
            </app-toolbar>
          </div>

          <div
            class="modal-body"
            #modalBodyEl
            [ngClass]="{
              'drag-handle': !!(draggableEnabled && useBodyAsDragHandle)
            }"
          >
            <ng-container *ngIf="!contentTpl?.templateRef; else contentTplRef">
              <ng-content></ng-content>
            </ng-container>
          </div>
        </app-card>
      </div>
    </app-scroll-view>
  </ng-template>
</app-overlay>

<ng-template #headerTitleTpl>
  <div class="modal-header-title" *ngIf="!!showModalTitle">
    {{ modalTitle }}
  </div>
</ng-template>

<ng-template #contentTplRef>
  <ng-template [ngTemplateOutlet]="contentTpl.templateRef"></ng-template>
</ng-template>
